/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const More: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M5 10C6.104 10 7 10.896 7 12C7 13.104 6.104 14 5 14C3.896 14 3 13.104 3 12C3 10.896 3.896 10 5 10ZM12 10C13.104 10 14 10.896 14 12C14 13.104 13.104 14 12 14C10.896 14 10 13.104 10 12C10 10.896 10.896 10 12 10ZM19 10C20.104 10 21 10.896 21 12C21 13.104 20.104 14 19 14C17.896 14 17 13.104 17 12C17 10.896 17.896 10 19 10Z'
      fill='currentColor'
    />
  </React.Fragment>
)
